import { API_PATH } from '../constants'
import { jwtDecode } from 'jwt-decode'
import axios from 'axios'

export const SetupInterceptors = (http: any, image: boolean) => {

    http.interceptors.request.use(
        async (config: any) => {
            if (localStorage.getItem('accessToken')) {
                if (localStorage.getItem('refreshToken')) {
                    let currentDate = new Date();
                    const decodedToken: { exp: number } = jwtDecode(localStorage.getItem('accessToken')!);
                    if (decodedToken.exp * 1000 < currentDate.getTime()) {
                        const refreshToken = localStorage.getItem('refreshToken')
                            ? localStorage.getItem('refreshToken')
                            : null
                        const refreshTokenResp = await axios.post(API_PATH + "/refresh", { refreshToken });
                        
                        localStorage.setItem('accessToken', refreshTokenResp.data.accessToken)
                        
                        if (image) {
                            config.headers['content-type'] = 'application/octet-stream' 
                        } else {
                            config.headers["authorization"] = `Bearer ${
                                refreshTokenResp.data.accessToken
                            }`;
                            config.headers['content-type'] = 'application/json' 
                        }
                    }
                    
                    if (image) {
                        config.headers['content-type'] = 'application/octet-stream' 
                    } else {
                        config.headers["authorization"] = `Bearer ${
                            localStorage.getItem('accessToken')
                        }`;
                        config.headers['content-type'] = 'application/json' 
                    }
                } else {
                    window.location.href = "/login";
                }
            } else {
                window.location.href = "/login";
            }
            return config
        },
        (error: any) => {
            return Promise.reject(error)
        }
    )

    http.interceptors.response.use(function(response: any) {
        return response
    }, function (error: any) {
        return Promise.reject(error)
    })
}